import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from '../general-components/Button';
import styles from './CatalogNumbers.module.css';
import ConditionalsTable from './conditionals/ConditionalsTable';

const CatalogNumbers: React.FC<{ data: any[] }> = ({ data }) => {
    const { t } = useTranslation();
    const [showInfo, setShowInfo] = useState(false);

    const toggle = () => {
        setShowInfo(!showInfo);
    };

    return (
        <>
            {data.filter((c) => c.value !== '').length > 0 && (
                <div className={styles.wrapper}>
                    <p className={styles.title}>
                        {t('catalogNumbers.title', { count: data.length })}{' '}
                        {!showInfo && (
                            <Button
                                small={true}
                                className={styles.button}
                                type={ButtonType.primary}
                                onClick={toggle}
                            >
                                {t('catalogNumbers.buttons.seeInfo')}
                            </Button>
                        )}
                        {showInfo && (
                            <Button
                                small={true}
                                className={styles.button}
                                type={ButtonType.secondary}
                                onClick={toggle}
                            >
                                {t('catalogNumbers.buttons.hide')}
                            </Button>
                        )}
                    </p>
                    {showInfo && (
                        <div className={styles.table}>
                            <ConditionalsTable
                                headers={[
                                    t(
                                        'catalogNumbers.table.headers.catalogNumber'
                                    ),
                                    t('catalogNumbers.table.headers.info'),
                                    t('catalogNumbers.table.headers.diameter'),
                                    t('catalogNumbers.table.headers.length'),
                                ]}
                                fields={data
                                    .filter((c) => c.value !== '')
                                    .map((c) => [
                                        c.value,
                                        c.info,
                                        c.diameter !== undefined &&
                                        c.diameter !== null
                                            ? `${c.diameter} ${t(
                                                  'catalogNumbers.units.mm'
                                              )}`
                                            : '',
                                        c.length !== undefined &&
                                        c.length !== null
                                            ? `${c.length} ${t(
                                                  'catalogNumbers.units.mm'
                                              )}`
                                            : '',
                                    ])}
                            />
                        </div>
                    )}
                </div>
            )}{' '}
        </>
    );
};

export default CatalogNumbers;
